import { render, staticRenderFns } from "./SnackbarAlert.vue?vue&type=template&id=f6a46e9a"
import script from "./SnackbarAlert.vue?vue&type=script&lang=js"
export * from "./SnackbarAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports